import BlockTimesState from './state';
import { BlockTime, RecurrenceType } from 'src/types';

/**
 * Get Block Time by Id.
 */
export const getBlockTime = (blockTimeId: string, recurrenceType: number=RecurrenceType.ONCE) => {
  const singleBlockTimes = BlockTimesState.blockTimes.single;
  const recurringBlockTimes = BlockTimesState.blockTimes.recurring;
  let allBlockTimes: BlockTime[]
  if (recurrenceType === RecurrenceType.ONCE) {
    allBlockTimes = [...singleBlockTimes];
  } else {
    allBlockTimes = [...recurringBlockTimes];
  }


  return allBlockTimes.find(
    (blockTime) => blockTime.id?.toString() === blockTimeId,
  );
};
